/**************************************************************************************************************************
 Copyright (c) 2022 WorkEarly Results LLP

     NAME: company-logo.tsx
   AUTHOR: Harikrishnan Gangadharan
 COMMENTS: 

/***************************************************************************************************************************
 STANDARD IMPORTS
****************************************************************************************************************************/
import { type FunctionComponent } from 'react';

import Assets from '@/constants/assets';
/***************************************************************************************************************************
 TYPES / GLOBAL DEFINITIONS
****************************************************************************************************************************/
interface CompanyLogoProps {
  width?: number;
  height?: number;
  goto?: string;
}
/***************************************************************************************************************************
 CLASSES / FUNCTIONS
****************************************************************************************************************************/
const Logo: FunctionComponent<CompanyLogoProps> = ({
  width = 300,
  height = 100,
  goto = '/'
}: CompanyLogoProps) => {



  return (
    <a
      className="w-fit bg-white flex flex-col items-center justify-start gap-3  rounded-[5px] shadow-md drop-shadow-md cursor-pointer"
      href={goto}>
      <img
        src={Assets.Images.LOGO.src}
        alt={Assets.Images.LOGO.alt}
        width={width}
        height={height}
      />
    </a>
  );
};

export default Logo;
